import theme from '@app/ui/theme'
import styled from 'styled-components'

export const OuterContainer = styled.div`
  width: 455px;
  border-radius: 5px;
  background-color: ${theme.colors.white};
  z-index: 10;
  border: 1px solid #e0e0e0;
  max-height: calc(100vh - 16px);
  overflow-y: auto;
  margin-bottom: 32px;
  @media (max-width: 1366px) {
    width: 400px;
  }
`
export const HeaderContainer = styled.div`
  border-bottom: 1px solid #cecece;
`

export const HeaderText = styled.span`
  font-size: 24px;
  font-weight: 500;
  margin-left: 40px;
`
export const SelectorText = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 24x;
  font-weight: 500;
  margin-bottom: 6px;
`

export const MiddleContainer = styled.div`
  padding-left: 40px;
  padding-right: 40px;
  position: relative;
`

export const ViewToggleContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  padding: 0 40px;
  margin-bottom: 12px;
  justify-content: flex-end;
`

export const ViewToggleButton = styled.button<{ active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: 1px solid ${({ active }) => (active ? '#000' : '#ccc')};
  border-radius: 6px;
  background-color: ${({ active }) => (active ? '#000' : '#fff')};
  color: ${({ active }) => (active ? '#fff' : '#333')};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;
`

export const ContentContainer = styled.div`
  padding-left: 40px;
  padding-right: 40px;
  flex-direction: row;
  flex-wrap: wrap;
  display: flex;
`

export const HoleContainer = styled.div`
  flex-basis: 0;
  flex-grow: 1;
  max-width: calc(33.3333% - 16px);
  margin: 8px;
  position: relative;
  @media (max-width: 820px) {
    max-width: calc(25% - 16px);
  }
`

export const DuplicateBadge = styled.div`
  position: absolute;
  top: -9px;
  right: 0;
  background-color: ${theme.colors.primary2};
  color: ${theme.colors.white};
  font-size: 10px;
  font-weight: 700;
  min-width: 18px;
  height: 18px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  z-index: 1;
`

export const CompactContentContainer = styled.div`
  padding-left: 40px;
  padding-right: 40px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`

export const CompactHoleItem = styled.div<{ selected?: boolean }>`
  width: calc(16.666% - 8px);
  margin: 4px;
  padding: 6px 4px;
  border-radius: 8px;
  border: 2px solid ${({ selected }) => (selected ? theme.colors.primary2 : '#e0e0e0')};
  background: ${({ selected }) => (selected ? `${theme.colors.primary2}0d` : '#fafafa')};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
  &:hover {
    border-color: ${theme.colors.secondary2};
  }
`

export const CompactHoleNumber = styled.span<{ selected?: boolean }>`
  font-size: 14px;
  font-weight: 700;
  color: ${({ selected }) => (selected ? theme.colors.primary2 : '#bbb')};
`

export const CompactHolePar = styled.span<{ selected?: boolean }>`
  font-size: 10px;
  color: ${({ selected }) => (selected ? 'rgba(0,0,0,0.5)' : '#999')};
`

export const TableContainer = styled.div`
  padding-left: 40px;
  padding-right: 40px;
  overflow-x: auto;
`

export const StyledTable = styled.table`
  width: 99%;
  margin-top: 5px;
  border-collapse: collapse;
`

export const TableHead = styled.thead``

export const TableHeaderCell = styled.th`
  font-size: 13px;
  letter-spacing: 1px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.8);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 3px;
  text-align: left;
`

export const TableRow = styled.tr<{ selected?: boolean }>`
  cursor: pointer;
  &:last-child > * {
    border-bottom: none !important;
  }
  &:hover > td {
    background: #fafafa;
  }
`

export const TableCell = styled.td<{ selected?: boolean }>`
  font-size: 16px;
  color: rgba(0, 0, 0, 0.8);
  font-weight: 600;
  text-align: left;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  min-height: 30px;
  padding: 5px;
  padding-left: 0;
`

export const SelectedPill = styled.div<{ selected?: boolean }>`
  border: 1px solid #ccc;
  border-radius: 18px;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  color: ${({ selected }) => (selected ? theme.colors.primary2 : 'rgba(0,0,0,0.4)')};
  border-color: ${({ selected }) => (selected ? theme.colors.primary2 : '#ccc')};
`

export const BottomContainer = styled.div`
  margin-left: 192px;
  margin-right: 40px;
`
